import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useContext, useRef, useState } from "react";
import { font } from "../../../styles/font";
import { theme } from "../../../styles/theme";

import {
  AccordionDetailsMA,
  AccordionMA,
  AccordionSummaryMA,
} from "../../../styles/styledComponents";
import { ApplicationContext } from "../../../context/application_ctx";
import dayjs from "dayjs";
import { UserProfile } from "..";

export const TableReadOnly = ({admin}) => {
  // context

  const { setHeader, header, licenceBatchList } =
    useContext(ApplicationContext);

  const scrollerAll = useRef(null);
  const scrollerDemo = useRef(null);
  const scrollerStandard = useRef(null);
  const [allAccordOpen, setAllAccordOpen] = useState(
    header === "Trial"
      ? 1
      : header === "Standard"
      ? 2
      : header === "Employees"
      ? 0
      : ""
  );

  // const [employeesList, setEmployeesList] = useState([
  //   // {
  //   //   epId: "cc",
  //   //   epName: null,
  //   //   epEmail: null,
  //   //   epDesignation: null,
  //   //   licenseStatus: "unallocated",
  //   // },
  //   {
  //     epId: "3839DD4",
  //     epName: "Antony",
  //     epEmail: "antony@gmail.com",
  //     epDesignation: "employee",
  //     licenseStatus: "allocated",
  //   },
  //   {
  //     epId: "filled",
  //     epName: "filled",
  //     epEmail: "filled",
  //     epDesignation: "filled",
  //     licenseStatus: "unallocated",
  //   },
  //   {
  //     epId: "filled",
  //     epName: "filled",
  //     epEmail: "filled",
  //     epDesignation: "filled",
  //     licenseStatus: "allocated",
  //   },
  //   {
  //     epId: "filled",
  //     epName: "filled",
  //     epEmail: "filled",
  //     epDesignation: "filled",
  //     licenseStatus: "unallocated",
  //   },
  // ]);

  let accordion = [
    { label: "All", type: "Employees" },
    { label: "Trial Licence", type: "Trial" },
    { label: "Standard Licence", type: "Standard" },
  ];
  const handleSelect = (i) => {
    setHeader(
      i === 0 ? "Employees" : i === 1 ? "Trial" : i === 2 ? "Standard" : ""
    );
    // !allAccordOpen.includes(i)
    //   ? allAccordOpen.push(i)
    //   : allAccordOpen.splice(allAccordOpen.indexOf(i), 1);
    setAllAccordOpen(allAccordOpen === i ? null : i);
  };
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        // alignItems="center"
        flex="1"
        width="100%"
      >
        {accordion.map((list, i) => {
          return (
            <AccordionMA
              //   elevation={0}
              //   sx={{ boxShadow:'none',borderRadius:'9px',border:'0px !important' }}
              disabled={
                ((licenceBatchList?.length < 2 ||
                  dayjs().isAfter(
                    licenceBatchList[licenceBatchList?.length - 1]
                      ?.expirationDate
                  )) &&
                i === 2) ||
               ( dayjs().isAfter(
                  licenceBatchList[0]
                    ?.expirationDate
                ) && i === 1)
              }
              sx={{
                borderTopLeftRadius: i === 0 ? "10px " : "0px",
                borderTopRightRadius: i === 0 ? "10px " : "0px",
                borderBottomRightRadius: i === 2 ? "10px " : "0px",
                borderBottomLeftRadius: i === 2 ? "10px " : "0px",
                overflow: "hidden",
              }}
              expanded={allAccordOpen === i}
            >
              <AccordionSummaryMA
                onClick={() => handleSelect(i)}
                //   expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  width="33%"
                  flexShrink={0}
                  color={theme.col_2}
                  fontFamily={font.family.fm_3}
                  fontWeight="bold"
                  fontSize={font.size.fs_5}
                  display="flex"
                  alignItems="center"
                  gap="12px"
                  whiteSpace="nowrap"
                >
                  {/* <LicenseIcon activeTab={2} /> */}
                  {list.label}
                </Typography>
              </AccordionSummaryMA>
              <AccordionDetailsMA>
                {allAccordOpen === i ? (
                  <UserProfile
                  admin={admin}
                    header={list.type}
                    index={i}
                    scrollerDemo={scrollerDemo}
                    scrollerStandard={scrollerStandard}
                    scrollerAll={scrollerAll}
                  />
                ) : (
                  <></>
                )}
              </AccordionDetailsMA>
            </AccordionMA>
          );
        })}
      </Box>
    </>
  );
};

// const EmployeeDataTableRow = ({
//   data,
//   licenceBatchList,
// }) => {
//   return (
//     <>
//       <TableRow
//         sx={{
//           height: "52px",
//         }}
//       >
//         <TableCell
//           size="small"
//           colSpan="1"
//           align="left"
//           style={{ minWidth: "150px", maxWidth: "150px" }}
//         >
//           <Box sx={{ maxWidth: "100%" }}>
//             <Typography display="flex" alignItems="center" gap="9px">
//               {/* <Avatar {...stringAvatar(data.name)} />
//                */}
//               <Box
//                 display="flex"
//                 alignItems="center"
//                 width="40px"
//                 minWidth="40px"
//                 height="40px"
//                 borderRadius="50px"
//                 flexDirection="column"
//                 justifyContent="center"
//                 backgroundColor={theme.col_14_alpha}
//               >
//                 <Typography
//                   fontFamily={font.family.fm_2}
//                   fontSize={font.size.fs_3}
//                   fontWeight="bold"
//                   color={theme.col_3}
//                   textTransform="capitalize"
//                 >
//                   {stringToArray(data.name)}
//                 </Typography>
//               </Box>
//               <Typography
//                 textTransform="capitalize"
//                 maxWidth="100%"
//                 noWrap="wrap"
//               >
//                 {data.name}
//               </Typography>
//             </Typography>
//           </Box>
//         </TableCell>
//         <TableCell
//           size="small"
//           colSpan="1"
//           align="left"
//           style={{ minWidth: "240px", maxWidth: "240px" }}
//         >
//           <Box sx={{ maxWidth: "100%" }}>
//             <Typography maxWidth="100%" noWrap="wrap">
//               {data.email}
//             </Typography>
//           </Box>
//         </TableCell>
//         <TableCell
//           size="small"
//           colSpan="1"
//           align="left"
//           style={{ minWidth: "150px", maxWidth: "150px" }}
//         >
//           <Box sx={{ maxWidth: "100%" }}>
//             <Typography maxWidth="100%" noWrap="wrap">
//               {data.designation}
//             </Typography>
//           </Box>
//         </TableCell>
//         <TableCell
//           size="small"
//           colSpan="1"
//           align="left"
//           style={{ minWidth: "150px", maxWidth: "150px" }}
//         >
//           <Tooltip
//             title={
//               <Box
//                 width="250px"
//                 display="flex"
//                 flexDirection="column"
//                 gap="6px"
//               >
//                 <Typography fontWeight="bold" fontSize={font.size.fs_3}>
//                   Licence Type : {data.licenseType}
//                 </Typography>
//                 <Typography fontWeight="bold" fontSize={font.size.fs_3}>
//                   Purchased on :{" "}
//                   {dayjs(
//                     data.licenseType === "demo"
//                       ? licenceBatchList[0]?.purchaseDate
//                       : licenceBatchList[1]?.purchaseDate
//                   ).format("DD MMMM YYYY")}
//                 </Typography>
//                 <Typography fontWeight="bold" fontSize={font.size.fs_3}>
//                   Valid upto :{" "}
//                   {dayjs(
//                     data.licenseType === "demo"
//                       ? licenceBatchList[0]?.expirationDate
//                       : licenceBatchList[1]?.expirationDate
//                   ).format("DD MMMM YYYY")}
//                 </Typography>
//               </Box>
//             }
//           >
//             <Typography
//               // width="fit-content"
//               // padding={"2px 8px"}
//               width="93px"
//               display="flex"
//               alignItems="center"
//               justifyContent="center"
//               height="25px"
//               textTransform="capitalize"
//               borderRadius="25px"
//               color={theme.col_3}
//               fontWeight="bold"
//               backgroundColor={theme.col_14_alpha}
//               fontSize={font.size.fs_4}
//               sx={{
//                 cursor: "pointer",
//                 "&:hover": { boxShadow: "0px 0px 6px -1px" },
//               }}
//             >
//               {data.licenseType}
//             </Typography>
//           </Tooltip>
//         </TableCell>

//         <TableCell
//           size="small"
//           // colSpan="2"
//           align="center"
//         >
//           <Box
//             className="detail"
//             sx={{ display: "flex", alignItems: "center", gap: "20px" }}
//           >
//             <OrganisationBadge status={data.isActive} />
//           </Box>
//           <Typography
//             display="none"
//             className="display"
//             alignItems="center"
//             gap="10px"
//           >
//             <ButtonCustom
//               fullWidth={true}
//               borderRadius="42px"
//               size="large"
//               background={theme.col_3_alpha}
//               backgroundRipple={theme.col_3_alpha}
//               focusColor={theme.col_1}
//               display="flex"
//               alignItems="center"
//               justifyContent="center"
//               typography={
//                 <Typography
//                   fontFamily={font.family.fm_2}
//                   textTransform={"capitalize"}
//                   fontSize={font.size.fs_4}
//                   fontWeight="bold"
//                   color={theme.col_3}
//                 >
//                   Update
//                 </Typography>
//               }
//             />
//             <ButtonCustom
//               fullWidth={true}
//               borderRadius="42px"
//               size="large"
//               background={theme.col_2_alpha}
//               backgroundRipple={theme.col_2_alpha}
//               focusColor={theme.col_1}
//               display="flex"
//               alignItems="center"
//               justifyContent="center"
//               typography={
//                 <Typography
//                   fontFamily={font.family.fm_2}
//                   textTransform={"capitalize"}
//                   fontSize={font.size.fs_4}
//                   fontWeight="bold"
//                   color={theme.col_2}
//                 >
//                   Revoke
//                 </Typography>
//               }
//             />
//           </Typography>
//         </TableCell>
//       </TableRow>
//     </>
//   );
// };

// const ProfileTabs = ({
//   tabs,
//   profileQuery,
//   employeesData,
//   loaderState,
//   setReloadEmployees,
//   revokedEmployeesData,
// }) => {
//   switch (tabs) {
//     case 1:
//       return (
//         <RegisteredUsers
//           setReloadEmployees={setReloadEmployees}
//           loaderState={loaderState}
//           employeesData={employeesData}
//           profileQuery={profileQuery}
//         />
//       );
//     case 2:
//       return (
//         <RevokedUsers
//           setReloadEmployees={setReloadEmployees}
//           loaderState={loaderState}
//           employeesData={employeesData}
//           profileQuery={profileQuery}
//           revokedEmployeesData={revokedEmployeesData}
//         />
//       );
//     default:
//       return;
//   }
// };

// const StatusBadge = ({ status }) => {
//   if (status === "allocated") {
//     return (
//       <Box
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 2,
//           padding: "2px 8px",
//           borderRadius: "14px",
//           backgroundColor: theme.statusSuccessAlpha,
//         }}
//       >
//         <Box
//           height="8px"
//           width="8px"
//           borderRadius="50px"
//           bgColor={theme.statusSuccess}
//         ></Box>
//         <Typography
//           fontWeight="bold"
//           variant="caption"
//           color={theme.statusSuccess}
//         >
//           Allocated
//         </Typography>
//       </Box>
//     );
//   } else {
//     return (
//       <Box
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 2,
//           padding: "2px 8px",
//           borderRadius: "14px",
//           backgroundColor: theme.statusDisabledAlpha,
//         }}
//       >
//         <Box
//           height="8px"
//           width="8px"
//           borderRadius="50px"
//           bgColor={theme.statusDisabled}
//         ></Box>
//         <Typography
//           fontWeight="bold"
//           variant="caption"
//           color={theme.statusDisabled}
//         >
//           Unallocated
//         </Typography>
//       </Box>
//     );
//   }
// };
